import {
  Address,
  Email,
  FirstName,
  JourneyAlias,
  JourneyId,
  LastName,
  NonEmptyText,
  ProductType,
  SubProductType,
  Url,
  UsPhone,
  UUID,
} from '@hc-frontend/core-types';
import { PlateName } from '@hc-frontend/features-leads';
import type { ZodFormattedError } from 'zod';
import { z } from 'zod';

export enum FieldNames {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  ADDRESS = 'address',
  PHONE_NUMBER = 'phoneNumber',

  LEAD_ID = 'universal_leadid',

  TRUSTED_FORM_URL = 'xxTrustedFormCertUrl',
  DISCLOSURE = 'disclosure',
  SUB_PRODUCT = 'subProduct',
  JOURNEY_ALIAS = 'journeyAlias',
  JOURNEY_ID = 'journeyId',
  PRODUCT = 'product',
  PLATE_NAME = 'plateName',
  INTERSTITIAL_EXPERIMENT = 'interstitialExperiment',
  INTERSTITIAL_PATH = 'interstitialPath',
}

export const UserInputs = z.object({
  [FieldNames.FIRST_NAME]: FirstName,
  [FieldNames.LAST_NAME]: LastName,
  [FieldNames.EMAIL]: Email,
  [FieldNames.PHONE_NUMBER]: UsPhone,
  [FieldNames.ADDRESS]: Address.optional().or(z.literal('')),
});

export const UserInputsOptional = z.object({
  [FieldNames.FIRST_NAME]: FirstName.optional().or(z.literal('')),
  [FieldNames.LAST_NAME]: LastName.optional().or(z.literal('')),
  [FieldNames.EMAIL]: Email.optional().or(z.literal('')),
  [FieldNames.PHONE_NUMBER]: UsPhone.optional().or(z.literal('')),
  [FieldNames.ADDRESS]: Address.optional().or(z.literal('')),
});

export type UserInputs = z.infer<typeof UserInputs>;
export type UserInputsOptional = z.infer<typeof UserInputsOptional>;

export const FormFields = UserInputs.merge(
  z.object({
    // Fields needed for selling the lead to a trusted partner
    [FieldNames.LEAD_ID]: UUID,
    [FieldNames.TRUSTED_FORM_URL]: Url,
    [FieldNames.DISCLOSURE]: NonEmptyText,

    [FieldNames.SUB_PRODUCT]: SubProductType.optional(),
    [FieldNames.JOURNEY_ALIAS]: JourneyAlias,
    [FieldNames.JOURNEY_ID]: JourneyId,
    [FieldNames.PRODUCT]: ProductType,
    [FieldNames.PLATE_NAME]: PlateName,
    [FieldNames.INTERSTITIAL_EXPERIMENT]: z.string().optional(),
    [FieldNames.INTERSTITIAL_PATH]: z.string().optional(),
  }),
);

export type FormFields = z.infer<typeof FormFields>;
export type FormState = ZodFormattedError<FormFields>;
export const leadIdUrl = 'https://create.lidstatic.com';
